import React from 'react';

import Header1 from '../../Layout/Header1';
import IndexIntro from './IndexIntro';
import IndexServices from './IndexServices';
import IndexHowWeWork from './IndexHowWeWork';
import ContactForm from '../../Shared/ContactForm/ContactForm';

const Index = () => (
  <>
    <Header1 />

    <IndexIntro />

    <IndexServices />

    <IndexHowWeWork />

    <ContactForm />
  </>
);

export default Index;
